import React, { useMemo } from 'react';
import { useVetRec } from '../../../providers/VetRecProvider';
import { LinkIcon } from '@heroicons/react/24/solid';
import { getPimsDisplayName } from '../../../utils/PimsUtils';

interface ExportButtonProps {
    handleVetSpireExport: (isFromButton: boolean) => void;
    handleOnPremPimsExport: (isFromButton: boolean) => void;
    buttonClassName?: string;
}

export const ExportButton: React.FC<ExportButtonProps> = (props) => {
    const { pims, syncOnPremPimsEnabled } = useVetRec()

    const pimsDisplayName = useMemo(() => {
        return getPimsDisplayName(pims)
    }, [pims])

    const name = useMemo(() => {
        if (pims.includes("on-prem") && syncOnPremPimsEnabled) return `Export to ${pimsDisplayName}`
        if (pims.includes("vetspire")) return "Export to Vetspire"
        return undefined
    }, [pims, syncOnPremPimsEnabled, pimsDisplayName])

    const method =  useMemo(() => {
        if (pims.includes("on-prem") && syncOnPremPimsEnabled) return props.handleOnPremPimsExport
        if (pims.includes("vetspire")) return props.handleVetSpireExport
        return undefined
    }, [pims, syncOnPremPimsEnabled, props.handleOnPremPimsExport, props.handleVetSpireExport])

    return name && method && <button
            type="button"
            title={`Export notes to ${name}`}
            className={`whitespace-nowrap inline-flex items-center gap-x-2 rounded-md bg-main-button px-3 py-2.5 text-sm font-semibold text-main-button-text shadow-sm hover:bg-main-button-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 h-10 lg:h-12 justify-center lg:w-auto w-full ${props.buttonClassName || ''}`}
            onClick={() => method(true)}
        >
            <LinkIcon className="flex-shrink-0 h-5 w-5 text-gray-200 group-hover:text-gray-300"/>
            <span>{name}</span>
        </button>
}